// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"JM-z","inlineTitle":"KM-z","sponsoredAdsWrapper":"LM-z","marketplaceRecosWrapper":"MM-z"};